import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'eap-material-loader',
  templateUrl: './material-loader.component.html',
  styleUrls: ['./material-loader.component.scss'],
  imports: [MatProgressSpinnerModule]
})
export class MaterialLoaderComponent {
  @Input() componentName = '';
  @Input() isWhiteText = false;
}
